interface Resource {url:string;sha256:string;bytes:number}
interface Manifest {version:string;resources:Resource[]}
const controlName='npt27-control-v1';const activeKey='/__npt27_active';
async function workerReady(){
 if(!navigator.serviceWorker)throw new Error('Service worker недоступен');
 const registration=await Promise.race([navigator.serviceWorker.ready,new Promise<never>((_,reject)=>setTimeout(()=>reject(new Error('Офлайн-модуль не активирован. Повторите после перезапуска.')),5000))]);
 const worker=registration.active;if(!worker)throw new Error('Service worker не активирован');
 await new Promise<void>((resolve,reject)=>{const channel=new MessageChannel();const timer=setTimeout(()=>{channel.port1.close();reject(new Error('Обновите приложение перед загрузкой пакета'));},3000);channel.port1.onmessage=e=>{clearTimeout(timer);channel.port1.close();e.data?.protocol===2?resolve():reject(new Error('Версия офлайн-модуля несовместима'));};worker.postMessage({type:'NPT27_STATUS'},[channel.port2]);});
}
async function hash(response:Response){const digest=await crypto.subtle.digest('SHA-256',await response.arrayBuffer());return Array.from(new Uint8Array(digest),b=>b.toString(16).padStart(2,'0')).join('');}
export async function verifyOffline():Promise<boolean>{
 if(!('caches' in globalThis))return false;
 await workerReady();
 const control=await caches.open(controlName);const active=await control.match(activeKey);if(!active)return false;
 const cache=await caches.open(await active.text());const manifestResponse=await cache.match('/offline-manifest.json');if(!manifestResponse)return false;
 const manifest:Manifest=await manifestResponse.json();
 for(const resource of manifest.resources){const response=await cache.match(resource.url);if(!response||await hash(response)!==resource.sha256)return false;}
 return true;
}
export async function downloadOffline(progress:(value:string)=>void,signal?:AbortSignal):Promise<void>{
 const response=await fetch('/offline-manifest.json',{cache:'no-store',signal});
 if(!response.ok)throw new Error('Офлайн-пакет доступен только в production-сборке');
 const manifest:Manifest=await response.json();
 if(!manifest.version||!Array.isArray(manifest.resources))throw new Error('Манифест пакета повреждён');
 const name=`npt27-package-${manifest.version}-${crypto.randomUUID()}`;
 const cache=await caches.open(name);
 try{
  for(let i=0;i<manifest.resources.length;i++){
   const resource=manifest.resources[i];
   const url=new URL(resource.url,location.origin);if(url.origin!==location.origin)throw new Error('Чужой ресурс в пакете');
   progress(`Загрузка ${i+1} из ${manifest.resources.length}`);
   const file=await fetch(resource.url,{cache:'no-store',signal});
   if(!file.ok||await hash(file.clone())!==resource.sha256)throw new Error(`Проверка ресурса не пройдена: ${resource.url}`);
   await cache.put(resource.url,file);
  }
  await cache.put('/offline-manifest.json',new Response(JSON.stringify(manifest)));
  if(signal?.aborted)throw new DOMException('Отменено','AbortError');
  await workerReady();
  const control=await caches.open(controlName);
  await control.put(activeKey,new Response(name));
 }catch(error){await caches.delete(name);throw error;}
}
